<div class="mt-5">
  <div class="br-tab">
    <nav class="tab-nav">
      <ul>
        @for (tab of tabs; track tab.id) {
          <li class="tab-item" [class]="{ active: tab.active }">
            <button
              type="button"
              aria-label="{{ tab.label }}"
              data-panel="panel-1-icons"
              (click)="onTabClick(tab.id)"
            >
              <span class="name">{{ tab.label }}</span>
            </button>
          </li>
        }
      </ul>
    </nav>
    <div class="tab-content">
      @for (tab of tabs; track tab.id) {
        <div
          class="tab-panel"
          [class]="{ active: tab.active }"
          id="panel-1-icons"
        >
          <div class="mt-4"></div>

          <app-table-filter-bar
            [title]="'Editais'"
            [searchColumn]="['numeroCiclo', 'anoCiclo', 'programa.nome']"
            [data]="tab.data?.content || []"
            (filterChange)="filterData($event, tab)"
          ></app-table-filter-bar>
          <table class="br-table">
            <thead>
              <tr>
                <th><strong>Número</strong></th>
                <th><strong>Ano</strong></th>
                <th><strong>Programa</strong></th>
                <th><strong>Número de Inscrição</strong></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (ciclo of tab.filteredData?.content; track ciclo.id) {
                <tr>
                  <td>{{ ciclo.numeroCiclo }}</td>
                  <td>{{ ciclo.anoCiclo }}</td>
                  <td>{{ ciclo.programa.nome }}</td>
                  <td>{{ ciclo.numeroInscricao || '-'}}</td>
                  @if (ciclo.inscricaoVigente) {
                    <td>
                      <div class="tooltip-container">
                        <br-button
                          type="button"
                          variant="secondary"
                          (click)="onCadastroProfissional(ciclo.id)"
                          ><i class="fa-solid fa-user-doctor"></i
                        ></br-button>
                        <span class="tooltip-text">Ingressar</span>
                      </div>
                    </td>
                  } @if (!ciclo.inscricaoVigente) {
                    <td></td>
                  }
                </tr>
              }
              @if (tab.data && tab.data?.content.length === 0) {
                <tr>
                  <td colspan="4" class="text-center">
                    Nenhum edital encontrado.
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <app-pagination
            *ngIf="tab.data && tab.data.page.totalElements > 0"
            [page]="tab.page + 1"
            [total]="tab.data.page.totalElements"
            [pageSize]="tab.size"
            (pageChange)="onChangePage($event, tab)"
            (exibicaoChange)="onItensPorPaginaAlterado($event, tab)"
          >
          </app-pagination>
        </div>
      }
    </div>
  </div>
</div>

<hr />

<div>
  <br-button type="button" [emphasis]="'secondary'" (click)="onBack()"
    >Voltar</br-button
  >
</div>
